import { Button } from "@/components/ui/button";
import { Edit, Lock, Unlock, Shield } from "lucide-react";

interface UserActionsProps {
  userId: string;
  status: 'active' | 'suspended';
  role: string;
  onStatusChange: (userId: string, action: 'activate' | 'suspend') => Promise<void>;
  onEdit: () => void;
  onRoleChange: () => void;
}

export const UserActions = ({ 
  userId, 
  status, 
  role,
  onStatusChange, 
  onEdit,
  onRoleChange 
}: UserActionsProps) => {
  return (
    <div className="flex items-center justify-end gap-2">
      <Button
        variant="outline"
        size="icon"
        onClick={() => onStatusChange(userId, status === 'suspended' ? 'activate' : 'suspend')}
        className="h-8 w-8"
      >
        {status === 'suspended' ? 
          <Unlock className="h-4 w-4" /> : 
          <Lock className="h-4 w-4" />
        }
      </Button>
      <Button 
        variant="outline"
        size="icon"
        onClick={onEdit}
        className="h-8 w-8"
      >
        <Edit className="h-4 w-4" />
      </Button>
      <Button
        variant="outline"
        size="icon"
        onClick={onRoleChange}
        className="h-8 w-8"
      >
        <Shield className="h-4 w-4" />
      </Button>
    </div>
  );
};